import { Tray } from '@phosphor-icons/react';

export default Tray;
